<template>
  <div
    class="createrHome_wrap">
    <div
      class="creater-header"
      :style="{
        paddingTop: stateHeight,
        background: bgColor,
      }"
    >
      <van-nav-bar :border="false" class="navbar" placeholder>
        <template #left>
          <div class="left">
            <img
              class="icon-back"
              src="../assets/img/activity/icon-back.png"
              @click="handleBack"
            />
          </div>
        </template>
        <template #title>
          <span>{{ title }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="creater-zone">
      <div class="inner">
        <div class="creater-block">
          <div class="avatar-baseinfo">
            <div class="avatar" :style="{
              backgroundImage: `url('${creatorInfo.avatar}')`,
            }"></div>
            <div class="baseinfo">
              <div class="nickname-subcribe">
                <span class="name">{{ creatorInfo.nickName }}</span>
                <span
                  v-if="!issubcribe"
                  class="btn-subcribe"
                  @click="clickFollowEvent(true)"
                >订阅</span>
                <span
                  v-else
                  class="btn-subcribe ed"
                  @click="clickFollowEvent(false)"
                >已订阅</span>
              </div>
              <div class="follow-zone">
                <span class="follows">{{ creatorInfo.followNums || '0' }} 粉丝</span>
                <span class="zones">{{ creatorInfo.activityNums || '0' }} 专区</span>
              </div>
            </div>
          </div>
          <div class="introduce">
            <div class="title">{{ creatorInfo.jobTitle }}</div>
            <div class="info">{{ creatorInfo.creatorDesc }}</div>
          </div>
        </div>
        <div class="zone-wrap">
          <div class="zone-top">
            <span class="tit">职位专区</span>
            <span class="tab">
              <span class="tab-btn" :class="[{'active': curTab==1 && creatorZoneList?.length != 0}]" @click="changeTab(1)">最新</span>
              <span class="tab-btn" :class="[{'active': curTab==2 && creatorZoneList?.length != 0}]" @click="changeTab(2)">最热</span>
            </span>
          </div>
          <Empty v-if="creatorZoneList?.length == 0 && !createrZoneLoading" text="暂无职位专区" />
          <div v-else class="zone-list">
            <van-list
              v-model="createrZoneLoading"
              :finished="createrZoneFinished"
              :immediate-check="false"
              :error.sync="createrZoneError"
              finished-text="没有更多内容了"
              offset="0"
              loading-text="正在加载…"
              error-text="请求失败，点击重新加载"
              @load="loadCreaterZone"
            >
              <div
                class="list sensors_exposure"
                v-for="(item, index) in creatorZoneList"
                :key="index"
                sensorsname="InfoListExposure"
                :sensorsdata="getInfoListExposure(item, index)"
                @click="goZonePage(item, index)"
              >
                <div class="zone-img">
                  <img :src="`${item.shareIcon}`" />
                </div>
                <div class="zone-con">
                  <span class="tit">{{ item.title }}</span>
                  <span class="time-views">
                    <span class="time">{{ formatCreatedTimeEvent(item.createTime) }}</span>
                    <span class="views">{{ item.viewCount }}</span>
                  </span>
                </div>
              </div>
            </van-list>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="cancleSubricePopup"
      position="bottom"
      class="cancle-popup-wrap"
    >
      <div class="cancle-popup" :class="[{'hidden': !cancleSubricePopup}]">
        <div class="inner">
          <span class="btn-cancle" @click="handleFollow(false)">取消订阅</span>
          <span class="btn-close-popup" @click="cancleSubricePopup = !cancleSubricePopup">返回</span>
        </div>
      </div>
    </van-popup>
    <div class="scroll-tip" @click="handleScrollTop"></div>
  </div>
</template>

<script>
import Empty from "@/components/common/EmptyData.vue";
export default {
  name: 'CreaterHome',
  components: {
    Empty,
  },
  data() {
    return {
      stateHeight: 0,
      bgColor: "",
      title: "",
      queryData: this.$route.query || {},
      createrZoneLoading: true,
      createrZoneFinished: false,
      createrZoneError: false,
      issubcribe: false,
      creatorInfo: {},
      creatorZoneList: [],
      pageNum: 1,
      pageSize: 20,
      orderType: 1, // 1-最新发布，2- 最多浏览
      cancleSubricePopup: false,
      curTab: 1,
    }
  },
  watch: {
    creatorInfo: {
      immediate: false,
      handler(nv) {
        this.issubcribe = nv.followed;
      }
    }
  },
  async mounted() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    const creatorInfo = this.$store.state.commonStore.creatorInfo;
    if (!creatorInfo || creatorInfo=='{}') {
      this.initCreaterSays();
    } else {
      this.creatorInfo = JSON.parse(creatorInfo);
      this.$nextTick(() => {
        this.loadCreaterZone();
      });
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.bgColor = "#ffffff";
        this.title = "大咖专区";
      } else {
        this.bgColor = "";
        this.title = "";
      }
    },
    handleScrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // 返回
    handleBack() {
      window.history.go(-1);
    },
    clickFollowEvent(subcribe) {
      if (subcribe) {
        this.handleFollow(true);
      } else {
        this.cancleSubricePopup = true;
      }
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_kocfollow",
        groupId: this.creatorInfo.id,
        contentType: subcribe?'关注':'取消关注',
      });
    },
    goZonePage(item, index) {
      this.$router.push({
        name: "Activity",
        params: {
          pageId: item.id
        },
      });
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_activitylist",
        ...JSON.parse(this.getInfoListExposure(item, index)),
      });
    },
    getInfoListExposure(item, index) {
      return JSON.stringify({
        groupId: this.creatorInfo.id,
        contentType: '职位专区',
        contentId: item.id,
        contentRank: index,
      })
    },
    changeTab(orderType) {
      this.pageNum = 1;
      this.orderType = orderType;
      this.creatorZoneList = [];
      this.curTab = orderType;
      this.createrZoneFinished = false;
      this.createrZoneError = false;
      this.createrZoneLoading = true;
      this.loadCreaterZone();
      
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_sorttype",
        groupId: this.creatorInfo.id,
        contentType: orderType==1?"最新发布":"最多浏览",
      });
    },
    async loadCreaterZone() {
      if (this.createrZoneFinished) return;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        creatorId: this.creatorInfo.id,
        orderType: this.orderType,
      }
      const res = await this.$api.activity.creatorActivityList(params);
      this.createrZoneLoading = false;

      if (res.code == '0') {
        const zoneList = res.data.result;
        this.creatorZoneList.push(...zoneList);
        this.pageNum++;
        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
        if (this.pageNum > Math.ceil(res.data.totalCount / params.pageSize)) {
          this.createrZoneFinished = true;
        }
      } else {
        this.createrZoneError = true;
      }
    },
    formatCreatedTimeEvent(time) {
      const nowTime = new Date();
      const zoneTime = new Date(time.replace(/-/g, '/'));
      const distanceTimestamp = parseInt(new Date(nowTime).getTime()/1000) - parseInt(new Date(zoneTime).getTime()/1000);
      const dhms = {
        y: nowTime.getFullYear() == zoneTime.getFullYear(),
        d: Math.floor(distanceTimestamp/60/60/24),
        h: Math.floor((distanceTimestamp/60/60)%24),
        m: Math.floor((distanceTimestamp/60)%60),
        s: Math.floor(distanceTimestamp%60),
      };
      let distanceTimeStr = "";
      if (dhms.d < 1) {
        if (dhms.h < 1 && dhms.m < 1) {
          distanceTimeStr = "刚刚";
        } else if (dhms.h < 1 && (dhms.m >= 1 && dhms.m < 60)) {
          distanceTimeStr = `${dhms.m}分钟前`;
        } else if (dhms.h >= 1 && dhms.h < 24) {
          distanceTimeStr = `${dhms.h}小时前`;
        }
      } else if (dhms.d >=1 && dhms.d < 4) {
        distanceTimeStr = `${dhms.d}天前`;
      } else {
        distanceTimeStr = `${!dhms.y?zoneTime.getFullYear()+'年':''}${zoneTime.getMonth()+1}月${zoneTime.getDate()}日`;
      }
      return distanceTimeStr;
    },
    initCreaterSays() {
      const params = {
        creatorId: this.$route.query.creatorid,
      };
      this.$api.activity.activityCreatorInfo(params).then((res) => {
        if (res.code == 0 && Object.keys(res.data).length !== 0) {
          this.creatorInfo = res.data,
          this.$store.commit("setValueLocalStorage", {
            creatorInfo: this.creatorInfo,
          });

          this.loadCreaterZone();
        }
      })
      
    },
    handleFollow(subcribe) {
      const params = {
        creatorId: this.creatorInfo.id,
        operationType: subcribe?'1':'2',
      }
      this.$api.activity.creatorFollowSet(params).then((res) => {
        if (res.code == '0' && res.data) {
          this.issubcribe = subcribe;
          const cI = JSON.parse(this.$store.state.commonStore.creatorInfo);
          cI.followed = this.issubcribe;
          if (!this.issubcribe) {
            cI.followNums-=1;
            this.cancleSubricePopup = false;
          } else {
            cI.followNums+=1;
          }

          this.creatorInfo = cI;
          this.$store.commit("setValueLocalStorage", {
            creatorInfo: this.creatorInfo,
          });

          this.$toast.success({
            message: this.issubcribe?'订阅成功':'取消订阅',
          });

          

        }
      })
    }
  }
}
</script>

<style lang="less">
#app {
  height: 100%;
}
</style>

<style lang="less" scoped>
.createrHome_wrap {
  padding-top: 158px;
  background: url('@/assets/img/activity/createrHome/createrHome_bg.png') top center no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 100%;

  .scroll-tip {
    position: fixed;
    width: 44px;
    height: 44px;
    background: url("@/assets/img/activity/btn_arrow_backtop.png") no-repeat
      center;
    background-size: 44px 44px;
    right: 15px;
    bottom: 98px;
    z-index: 3;
  }

  .creater-header {
    min-height: 44px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    .pc & {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999;
      width: 375px;
    }
    .left {
      display: flex;
    }
    /deep/.van-nav-bar {
      height: 44px;
      width: 100%;
      .van-nav-bar__content {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px 0 16px;
        position: relative;
        .van-nav-bar__title {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 16px;
        }
      }
    }
    .icon-back {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
  }

  .creater-zone {
    display: block;
    background: #fff;
    border-radius: 16px 16px 0 0;
    position: relative;
    padding-bottom: 18px;
    min-height: 100%;

    .inner {
      display: block;
      position: relative;
      top: -52px;
    }
    .creater-block {
      padding: 0 18px 20px 12px;
      display: block;
      position: relative;

      .avatar-baseinfo {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        width: 100%;

        .avatar {
          display: block;
          flex-shrink: 0;
          flex-grow: 0;
          width: 80px;
          height: 80px;
          box-sizing: border-box;
          background: #fff;
          border: 1px solid rgba(34, 34, 34, 0.25);
          border-radius: 40px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }

        .baseinfo {
          flex-shrink: 1;
          flex-grow: 1;
          display: block;
          padding: 0 0 0 12px;

          .nickname-subcribe {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;

            .name {
              display: block;
              flex: 1;
              max-width: 195px;
              font-size: 18px; 
              font-weight: 600;
              line-height: 20px;
              color: #222222;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .btn-subcribe {
              display: block;
              flex-shrink: 0;
              margin-left: 2px;
              background: #FE6300;
              color: #fff;
              width: 56px;
              height: 24px;
              line-height: 24px;
              border-radius: 13px;
              opacity: 1;
              font-size: 12px;
              font-weight: 600;
              text-align: center;

              &.ed {
                background: #FFA475;
              }
            }
          }

          .follow-zone {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-top: 4px;

            .follows, .zones {
              font-size: 14px;
              font-weight: 400;
              line-height: 18px;
              color: #666666;
            }

            .zones {
              margin-left: 12px;
            }
          }
        }
      }

      .introduce {
        padding: 18px 0 0;

        .title {
          display: block;
          position: relative;
          padding-left: 36px;
          font-size: 14px;
          font-weight: 600;
          line-height: 18px;
          color: #222222;

          &::after {
            display: block;
            position: absolute;
            top: 50%;
            left: 0;
            width: 28px;
            height: 14px;
            margin-top: -7px;
            content: '';
            background: url('@/assets/img/activity/createrHome/icon-creater-cert.png') center no-repeat;
            background-size: contain;
          }
        }
        .info {
          padding-top: 6px;
          font-size: 12px;
          font-weight: normal;
          line-height: 18px;
          color: #666666;
        }
      }
    }

    .zone-wrap {
      display: block;
      padding: 52px 0 0;
      margin: 0 18px;
      position: relative;
      box-sizing: border-box;

      /deep/ .empty_wrap {
        padding-top: 60px;
        >div {
          img {
            width: 180px;
            height: auto;
          }
          p {
            color: #AFB3BA;
          }
        }
      }
      
      &::before {
        display: block;
        border-top: 1px solid #D8D8D8;
        width: 100%;
        position: absolute;
        content: '';
        top: 0;
        box-sizing: border-box;
      }

      .zone-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        z-index: 10;
        top: 20px;
        height: 20px;
        width: 100%;

        .tit {
          flex: 1;
          font-size: 18px;
          font-weight: 600;
          line-height: 20px;
          color: #222222;
        }

        .tab {
          flex-grow: 0;
          flex-shrink: 1;

          &-btn {
            display: inline-block;
            padding-left: 20px;
            position: relative;
            font-size: 12px;
            line-height: 20px;
            color: #8F8F8F;

          }

          &-btn.active {
            color: #222222;

            &::before {
              display: block;
              content: '';
              width: 4px;
              height: 12px;
              position: absolute;
              left: 12px;
              top: 50%;
              margin-top: -6px;
              background: url('@/assets/img/activity/createrHome/icon-tab-btn.png') center no-repeat;
              background-size: contain;
            }
          }
        }
      }

      .zone-list {
        .list {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 8px 0;
          position: relative;

          .zone-img {
            display: block;
            content: '';
            flex-grow: 0;
            flex-shrink: 1;
            width: 96px;
            height: 96px;
            border: 1px solid #D8D8D8;
            border-radius: 4px;
            position: relative;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }
          .zone-con {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-flow: column;
            flex: 1;
            padding-left: 20px;
            height: 96px;

            .tit {
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              white-space: normal;
              text-overflow: ellipsis;
              width: 100%;
              font-size: 14px;
              font-weight: 600;
              line-height: 24px;
              color: #222222;

            }

            .time-views {
              display: flex;
              width: 100%;
              justify-content: space-between;
              align-items: center;
              font-size: 11px;
              font-weight: normal;
              line-height: 16px;
              color: #666666;

              .time {
                display: block;
                flex-grow: 0;
                flex-shrink: 1;
              }
              .views {
                display: block;
                flex-grow: 0;
                flex-shrink: 1;
                padding-left: 22px;
                position: relative;
                
                &::before {
                  display: block;
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 50%;
                  width: 16px;
                  height: 10px;
                  margin-top: -5px;
                  background: url('@/assets/img/activity/createrHome/icon-zone-views.png') center no-repeat;
                  background-size: contain;
                }
              }
            }
          }
        }
        
        /deep/ .van-list__error-text,
        /deep/ .van-list__finished-text,
        /deep/ .van-list__loading {
          padding: 40px 71px;
          text-align: center;
          color: #AFB3BA;
        }
      }
    }
  }

  .cancle-popup-wrap {
    width: 100% !important;
    background: transparent;

    .cancle-popup {
      display: block;
      position: relative;
      border-radius: 16px 16px 0 0;
      background: #fff;
      width: 100%;
      margin: 0 auto;
      transform: translateY(100%);
      animation: bottomToShow 0.5s ease 0s forwards;
      -webkit-animation: bottomToShow 0.5s ease 0s forwards;
    }

    .cancle-popup.hidden {
      transform: translateY(0);
      animation: topToHidden 0.5s ease 0s forwards;
      -webkit-animation: topToHidden 0.5s ease 0s forwards;
    }

    .inner {
      padding: 17px 16px 45px; 
      .btn-cancle, .btn-close-popup {
        display: block;
        border-radius: 4px;
        text-align: center;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        color: #4E525A;
      }
      .btn-cancle {
        background: #F7F7F7;
        margin-bottom: 5px;
        color: #222222;
      }
    }

  }
}

@keyframes bottomToShow {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
@-webkit-keyframes bottomToShow {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes topToHidden {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
@-webkit-keyframes topToHidden {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>